import { ArgsProps } from "antd/lib/notification";
import { AxiosError } from "axios";
import { t } from "i18next";
import { msgQueueStore } from "src/components/MsgQueue";
import { ZodError } from "zod";

import { ParseError } from "./dataParser";

export const getErrorMessage = (srcError: unknown): ArgsProps => {
  const e: Error = cvtError(srcError);
  // Все консольные сообщения тут удалены, т.к. функция вызывается не в момент возникновения ошибки.
  // Например, при выводе сообщения об ошибке под полем формы.
  // Поэтому консольные ошибки надо выдавать не тут.
  if (e instanceof ZodError) {
    return {
      message: t("Incorrect format of received data"),
    };
  }
  if (e instanceof ParseError) {
    if (e.cause instanceof ZodError) {
      return { message: e.message };
    }
  }
  const axiosError = e as AxiosError;
  if (axiosError?.isAxiosError) {
    const info = axiosError.response?.data;
    let description: string = `${t("Status")}: ${axiosError.response?.status}`;

    if (info && typeof info === "object") {
      if ("message" in info && typeof info.message === "string") {
        const { message } = info;
        if ("code" in info && typeof info.code === "number") {
          const { code } = info;
          description = `${code} - ${message}`;
        } else description = message;
      }
    }
    if (axiosError?.response?.status === 400) {
      return { message: t("Attention!"), description, type: "warning" };
    }
    if (axiosError?.response?.status === 403) {
      return { message: t("Access denied"), description, type: "error" };
    }
    return { message: t("Server error"), description };
  }
  return { message: e.message };
};

export const onError = (src: unknown): void => {
  const e = cvtError(src);
  const argProps: ArgsProps = { type: "error", ...getErrorMessage(e) };
  // eslint-disable-next-line no-console
  console.error(e); // чтобы проще найти место ошибки
  msgQueueStore.add(argProps);
};

export const cvtError = (srcError: unknown): Error => {
  if (srcError instanceof Error) return srcError;
  if (typeof srcError === "string") return Error(srcError);
  return Error("Unknown Error");
};
